/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import Vue from "vue";
import Vuex from "vuex";
import templatesApi from "~/api/templates";
import ROUTE from "~/constants/routes";
import router from "~/router";
import { templatesTableList } from "~/helpers/dataIteration";

import moment from "moment";

Vue.use(Vuex);

const state = {
  templates: {},
  templatesList: [],

  templatesStatics: null,
  templatesStaticsList: [],

  plansList: [],
  plans: null,

  keywordsList: [],
  keywords: null,

  holidaysList: [],
  holidays: null,

  bannersList: [],
  banners: null,

  template: null,
  error: {},
  validationErrors: {},
  loadingProcess: false,
};

const mutations = {
  setTemplatesStaticsList: (state, payload) => {
    state.templatesStaticsList = payload;
  },
  setTemplatesStatics: (state, payload) => {
    state.templatesStatics = payload;
  },

  setTemplatesList: (state, payload) => {
    state.templatesList = payload;
  },
  setTemplates: (state, payload) => {
    state.templates = payload;
  },

  setPlansList: (state, payload) => {
    state.plansList = payload;
  },
  setPlans: (state, payload) => {
    state.plans = payload;
  },

  setKeywordsList: (state, payload) => {
    state.keywordsList = payload;
  },
  setKeywords: (state, payload) => {
    state.keywords = payload;
  },

  setHolidaysList: (state, payload) => {
    state.holidaysList = payload;
  },
  setHolidays: (state, payload) => {
    state.holidays = payload;
  },

  setBannersList: (state, payload) => {
    state.bannersList = payload;
  },
  setBanners: (state, payload) => {
    state.banners = payload;
  },

  setTemplate: (state, payload) => {
    state.template = payload;
  },
  setError: (state, payload) => {
    state.error = payload;
  },
  setValidationErrors: (state, payload) => {
    state.validationErrors = payload;
  },
  setLoading: (state, payload) => {
    state.loadingProcess = payload;
  },
};

const actions = {
  getTemplatesList({ commit }, payload) {
    commit("setLoading", true);
    templatesApi
      .getTemplatesList(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        commit("setTemplatesList", templatesTableList(res.data[0].data));
        commit("setTemplates", res.data[0]);
      })
      .catch((error) => {
        console.log(error);
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  getTemplatesStatisticsList({ commit }, payload) {
    commit("setLoading", true);
    templatesApi
      .getTemplatesStatistics(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        commit("setTemplatesStatics", res.data.items);
        const list = Object.values(res.data.items);
        for (let i = 0; list.length > i; i++) {
          list[i].group = list[i].groups[0].name;

          const statuses = Object.keys(list[i].statuses);
          for (let a = 0; statuses.length > a; a++) {
            list[i][statuses[a]] = list[i].statuses[statuses[a]];
          }
        }
        commit("setTemplatesStaticsList", list);
      })
      .catch((error) => {
        console.log(error);
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  getItemTemplate({ commit }, payload) {
    commit("setLoading", true);
    templatesApi
      .getItemTemplate(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        commit("setTemplate", res.data);
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  createTemplate({ commit }, payload) {
    commit("setLoading", true);
    templatesApi
      .createTemplate(payload)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          router.push({
            path: ROUTE.TEMPLATES_LIST.replace(":page", 1),
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  editTemplate({ commit }, { url, editData }) {
    commit("setLoading", true);
    templatesApi
      .editTemplate(url, editData)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          router.push({
            path: ROUTE.TEMPLATES_LIST.replace(":page", 1),
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  templateCheckSeo({ commit }, payload) {
    commit("setLoading", true);
    templatesApi
      .templateCheckSeo(payload)
      .then((res) => {
        if (!res.data.exists) {
          commit("setError", {});
          commit("setValidationErrors", {});
        } else {
          commit("setValidationErrors", {
            seoName: ["The SEO Name of Template has already been taken."],
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  // Content Plans

  getPlansList({ commit }, payload) {
    commit("setLoading", true);
    templatesApi
      .getPlansList(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        const plans = res.data[0].data;

        for (let i = 0; plans.length > i; i++) {
          plans[i].month = moment(plans[i].endDate).format("MMMM");
          plans[i].year = moment(plans[i].endDate).format("YYYY");
        }
        commit("setPlansList", plans);
        commit("setPlans", res.data[0]);
      })
      .catch((error) => {
        console.log(error);
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  // Keywords

  getKeywordsList({ commit }, payload) {
    commit("setLoading", true);
    templatesApi
      .getKeywordsList(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        const keywords = res.data[0].data;

        for (let i = 0; keywords.length > i; i++) {
          if (keywords[i].parentId) {
            keywords[i].type = "child";
          } else {
            keywords[i].type = "parent";
          }

          if (keywords[i].category) {
            keywords[i].category_name = keywords[i].category[0]?.fullName.replace(
              "Freebies / ",
              "",
            );
          }

          keywords[i].keyPoints =
            keywords[i].keyPoints && keywords[i].keyPoints.length > 0 ? "yes" : "no";

          keywords[i].targetAudience =
            keywords[i].targetAudience && keywords[i].targetAudience.length > 0 ? "yes" : "no";

          keywords[i].templateOverview =
            keywords[i].templateOverview && keywords[i].templateOverview.length > 0 ? "yes" : "no";

          keywords[i].previewRequirements =
            keywords[i].previewRequirements && keywords[i].previewRequirements.length > 0
              ? "yes"
              : "no";

          if (
            keywords[i].keyPoints == "yes" &&
            keywords[i].targetAudience == "yes" &&
            keywords[i].templateOverview == "yes" &&
            keywords[i].previewRequirements == "yes"
          ) {
            keywords[i].fieldStatus = "green";
          } else {
            keywords[i].fieldStatus = "red";
          }
        }
        commit("setKeywordsList", keywords);
        commit("setKeywords", res.data[0]);
      })
      .catch((error) => {
        console.log(error);
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  createKeywords({ commit }, payload) {
    commit("setLoading", true);
    templatesApi
      .createKeywords(payload)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          router.push({
            path: ROUTE.KEYWORDS_LIST.replace(":page", 1),
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  createKeywordsArray({ commit }, payload) {
    commit("setLoading", true);
    templatesApi
      .createKeywordsArray(payload)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          router.push({
            path: ROUTE.KEYWORDS_LIST.replace(":page", 1),
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
          console.log(data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  editKeywords({ commit }, { url, editData }) {
    commit("setLoading", true);
    templatesApi
      .editKeywords(url, editData)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          router.push({
            path: ROUTE.KEYWORDS_LIST.replace(":page", 1),
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  //Holidays

  getHolidaysList({ commit }, payload) {
    commit("setLoading", true);
    templatesApi
      .getHolidaysList(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        const holidays = res.data[0].data;

        for (let i = 0; holidays.length > i; i++) {}
        commit("setHolidaysList", holidays);
        commit("setHolidays", res.data[0]);
      })
      .catch((error) => {
        console.log(error);
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  createHolidays({ commit }, payload) {
    commit("setLoading", true);
    templatesApi
      .createHolidays(payload)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          router.push({
            path: ROUTE.HOLIDAYS_LIST.replace(":page", 1),
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  editHolidays({ commit }, { url, editData }) {
    commit("setLoading", true);
    templatesApi
      .editHolidays(url, editData)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          router.push({
            path: ROUTE.HOLIDAYS_LIST.replace(":page", 1),
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  //Banners

  getBannersList({ commit }, payload) {
    commit("setLoading", true);
    templatesApi
      .getBannersList(payload)
      .then((res) => {
        commit("setError", {});
        commit("setValidationErrors", {});
        const items = res.data[0].data;

        for (let i = 0; items.length > i; i++) {}
        commit("setBannersList", items);
        commit("setBanners", res.data[0]);
      })
      .catch((error) => {
        console.log(error);
        const { data } = error.response;
        commit("setError", data);
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  createBanners({ commit }, payload) {
    commit("setLoading", true);
    templatesApi
      .createBanners(payload)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          router.push({
            path: ROUTE.BANNERS_LIST.replace(":page", 1),
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },

  editBanners({ commit }, { url, editData }) {
    commit("setLoading", true);
    templatesApi
      .editBanners(url, editData)
      .then((res) => {
        if (res.success) {
          commit("setError", {});
          commit("setValidationErrors", {});
          router.push({
            path: ROUTE.BANNERS_LIST.replace(":page", 1),
          });
        }
      })
      .catch((error) => {
        const { data } = error.response;
        commit("setError", data);
        if (data.errors) {
          commit("setValidationErrors", data.errors);
        }
      })
      .finally(() => {
        commit("setLoading", false);
      });
  },
};

const getters = {};

const templates = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
export default templates;
